import {
  TPivotPresetName,
  TPivotReportPreset,
} from '@infotech-soe/merps/types/Reports';
import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from '../reducers/root';

export const getPivotState = (state: AppState) => state.pivot;

const getPivotPresets = (
  state: AppState
): Record<TPivotPresetName, TPivotReportPreset> | undefined =>
  state.pivot.config?.presets;

export const getPivotPresetNames = createSelector(getPivotPresets, presets =>
  presets ? Object.keys(presets) : []
);
